module.exports = (node, defaultPath = '/', prefixPath = false) => {
  if (!node || !node.data) return
  let path = node.data.path
    ? `${prefixPath ? prefixPath : ''}/${node.data.path}`
    : defaultPath
  return path && path.replace(/\/{2,}/g, '/')
}
